module.exports = __webpack_public_path__ + "img/not-found.ac00e23a.png";